import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { DisplayLabel } from '../models/displayLabel';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TrainingAreaService {
  constructor(private readonly api: ApiService) {}

  @PCacheable()
  public async findAll(): Promise<DisplayLabel[]> {
    return this.api.get<DisplayLabel[]>(environment.api.trainingAreas);
  }

  public async findAllById(): Promise<Map<number, DisplayLabel>> {
    const trainingAreas: DisplayLabel[] = await this.findAll();
    return new Map<number, DisplayLabel>(trainingAreas.map((type: DisplayLabel) => [type.id, type] as [number, DisplayLabel]));
  }
}
